// extracted by mini-css-extract-plugin
module.exports = {"toggleLayout":"styles_toggleLayout__7jv9E","togglePrivate":"styles_togglePrivate__iib17"};